import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { TabContext, TabList } from "@mui/lab";

import PodcastList from "./PodcastList";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
const PodcastTabPanel = (props) => {
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [total, setTotal] = useState(0);
  const [numberPodcast, setNumberPodcast] = useState(0);

  const handleChange = (event, newValue) => {
    setTotal(0);
    setNumberPodcast(0);
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            centered
          >
            <Tab
              label={
                value == 0 ? `Drafts (${numberPodcast}/${total})` : `Drafts`
              }
              {...a11yProps(0)}
              sx={{
                px: 8,
                textTransform: "inherit",
                fontWeight: "600",
                color: "#a1b8fc",
                fontSize: "1rem",
                "@media (min-width: 1636px)": { fontSize: "1.4rem" },
              }}
            />
            <Tab
              label={
                value == 1
                  ? `Approval Pending (${numberPodcast}/${total})`
                  : `Approval Pending`
              }
              {...a11yProps(1)}
              sx={{
                px: 8,
                textTransform: "inherit",
                fontWeight: "600",
                color: "#a1b8fc",
                fontSize: "1rem",
                "@media (min-width: 1636px)": { fontSize: "1.4rem" },
              }}
            />
            <Tab
              label={
                value == 2 ? `Approved (${numberPodcast}/${total})` : `Approved`
              }
              {...a11yProps(2)}
              sx={{
                px: 8,
                textTransform: "inherit",
                fontWeight: "600",
                color: "#a1b8fc",
                fontSize: "1rem",
                "@media (min-width: 1636px)": { fontSize: "1.4rem" },
              }}
            />
            <Tab
              label={
                value == 3 ? `Rejected (${numberPodcast}/${total})` : `Rejected`
              }
              {...a11yProps(3)}
              sx={{
                px: 8,
                textTransform: "inherit",
                fontWeight: "600",
                color: "#a1b8fc",
                fontSize: "1rem",
                "@media (min-width: 1636px)": { fontSize: "1.4rem" },
              }}
            />
          </TabList>
        </Box>
        <TabPanel
          value={value}
          index={0}
          dir={theme.direction}
        >
          <PodcastList
            filter="new"
            setTotalNumber={(t) => {
              setTotal(t);
            }}
            setPodcastNumber={(a) => {
              setNumberPodcast(a);
            }}
          ></PodcastList>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <PodcastList
            filter="approvalPending"
            setTotalNumber={(t) => {
              setTotal(t);
            }}
            setPodcastNumber={(a) => {
              setNumberPodcast(a);
            }}
          ></PodcastList>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <PodcastList
            filter="approved"
            setTotalNumber={(t) => {
              setTotal(t);
            }}
            setPodcastNumber={(a) => {
              setNumberPodcast(a);
            }}
          ></PodcastList>
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          <PodcastList
            filter="rejected"
            setTotalNumber={(t) => {
              setTotal(t);
            }}
            setPodcastNumber={(a) => {
              setNumberPodcast(a);
            }}
          ></PodcastList>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default PodcastTabPanel;
